export const model = {
    id: null,
    name: '', 
    corps_id: '',   
    created_at: '',
    updated_at: ''
};
